var app = {

    init: function() {
		console.log('init')
		app.addEvents();
		app.scrollOnPagination();
		app.handleBackToTopButton();
	},

	addEvents: function() {
    	jQuery('.js-ui-button').on('click', app.handleToggleMenu);
		jQuery('.js-cooptation-button').on('click', app.handleToggleCooptation);
		jQuery('#back-to-top-btn').on('click', app.topFunction);
	},

	scrollOnPagination:function() {
		if ((~window.location.href.indexOf("/candidat-offres-emploi-agence-de-recrutement/page/")) || (window.location.pathname == '/candidat-offres-emploi-agence-de-recrutement/' && ~document.referrer.indexOf("page"))) {
			$('html, body').animate({
				scrollTop: $(".candidat-offres-emploi-pagination-scroll").offset().top
			}, 2000);
		}
	},

	handleToggleMenu: function(event) {
    	event.preventDefault();
    	jQuery('.menu').toggleClass('menu-visible');
    },

	handleToggleCooptation: function(event) {
    	event.preventDefault();
    	jQuery('.menu-cooptation').toggleClass('cooptation-visible');
    },

	topFunction:function() {
        $('html, body').animate({
            scrollTop: $("html, body").offset().top
        }, 1000);
    },

	handleBackToTopButton:function() {

		backToTopButton = document.getElementById("back-to-top-btn");

        window.onscroll = function() {
			scrollFunction()
		};

        function scrollFunction() {
            if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
                backToTopButton.style.display = "block";
            } else {
                backToTopButton.style.display = "none";
            }
        }
		
	}
};

$(app.init);